import { useState } from 'react';

const qaItems = [
  {
    q: 'What does Air-Tek NC do?',
    a: 'Air-Tek NC provides professional HVAC services including installation, repair, and maintenance of heating and cooling systems for residential and commercial properties across North Carolina. We are available 24/7 and offer 100% financing.',
  },
  {
    q: 'What HVAC services are offered?',
    a: 'Air conditioning repair and installation, heating system services (furnaces and heat pumps), HVAC maintenance and tune-ups, indoor air quality solutions, and commercial HVAC support for businesses of all sizes.',
  },
  {
    q: 'What are the benefits of choosing Air-Tek NC?',
    a: 'Improved energy efficiency, reliable indoor comfort year-round, better air quality, and reduced long-term repair costs — backed by experienced technicians, transparent pricing, and over a decade of real-world experience.',
  },
  {
    q: 'What is the Air-Tek NC service process?',
    a: 'System evaluation → clear recommendations with no unnecessary upsells → professional installation or repair → ongoing maintenance support. We get the job done correctly the first time.',
  },
];

export default function AIAnswerBlock() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section className="bg-[#f8f9fa] py-20">
      <div className="max-w-[1000px] mx-auto px-6 md:px-10">
        <div className="text-center mb-12">
          <span className="text-[#00d4ff] text-xs font-bold tracking-widest uppercase">HVAC Services Explained</span>
          <h2
            className="text-3xl md:text-4xl font-bold text-[#0a1628] mt-3 mb-3"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            Everything About Our HVAC Services
          </h2>
          <p className="text-[#6b7280] text-base">Quick answers about Air-Tek NC and what we offer.</p>
        </div>

        <div className="space-y-3">
          {qaItems.map((item, idx) => (
            <div key={idx} className="bg-white rounded-xl border border-gray-200 overflow-hidden">
              <button
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-gray-50 transition-colors duration-200"
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
              >
                <div className="flex items-center gap-3">
                  <div className="w-1 h-6 bg-[#00d4ff] rounded-full shrink-0" />
                  <span className="text-[#0a1628] font-semibold text-base">{item.q}</span>
                </div>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#00d4ff]/10 shrink-0 ml-4">
                  <i className={`text-[#00d4ff] text-base ${openIdx === idx ? 'ri-subtract-line' : 'ri-add-line'}`} />
                </div>
              </button>
              {openIdx === idx && (
                <div className="px-6 pb-5 pl-[52px]">
                  <p className="text-[#4b5563] text-base leading-relaxed">{item.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
